import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M13.05 4.425a.375.375 0 01-.3-.367V3.75a.75.75 0 10-1.5 0v.308a.375.375 0 01-.3.367 5.25 5.25 0 00-3.548 2.61.188.188 0 000 .188.18.18 0 00.158.09h8.872a.18.18 0 00.158-.09.188.188 0 000-.188 5.25 5.25 0 00-3.54-2.61zM7.26 8.063a.383.383 0 00-.367.284 5.385 5.385 0 00-.143 1.216v2.482c0 .105.075.15.165.098l4.17-2.34a1.89 1.89 0 011.83 0l4.17 2.34c.09.052.165 0 .165-.098V9.563a5.385 5.385 0 00-.142-1.216.382.382 0 00-.368-.284H7.26z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17.055 12.983l-4.5-2.528a1.095 1.095 0 00-1.095 0l-4.5 2.528a.383.383 0 00-.05.63.36.36 0 00.23.075.382.382 0 01.375.375v5.362a.39.39 0 01-.128.285.75.75 0 00-.262.54.75.75 0 00.75.75h8.25a.75.75 0 00.75-.75.75.75 0 00-.248-.54.391.391 0 01-.127-.285v-5.362a.383.383 0 01.375-.375.36.36 0 00.36-.278.382.382 0 00-.18-.427zm-6.18.705a.382.382 0 01.375.375v5.062a.382.382 0 01-.375.375h-1.5A.382.382 0 019 19.125v-5.062a.382.382 0 01.375-.375h1.5zM15 19.125a.382.382 0 01-.375.375h-1.5a.382.382 0 01-.375-.375v-5.062a.383.383 0 01.375-.375h1.5a.382.382 0 01.375.375v5.062zM5.625 12.938h-1.5A1.125 1.125 0 003 14.062v4.688a.75.75 0 00.75.75h1.875A.375.375 0 006 19.125v-5.813a.375.375 0 00-.375-.374zM19.875 12.938h-1.5a.375.375 0 00-.375.374v5.813a.375.375 0 00.375.375h1.875a.75.75 0 00.75-.75v-4.688a1.125 1.125 0 00-1.125-1.124z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
